function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M9 19v-2.2c0-1.8 1.3-3.2 3-3.2s3 1.4 3 3.2V19H9zm-1 2H3l2-9.1 2.6-2.2.4-3.3L15 4l1.6 5.6 2.4.9L21 21H8z",
  fill: "currentColor",
  fillRule: "evenodd"
});

function SvgLocationCave(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationCave);
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0IiB2ZXJzaW9uPSIxIj48ZyBzdHlsZT0iZmlsbC1ydWxlOmV2ZW5vZGQ7ZmlsbDpub25lIj48ZyBmaWxsPSJjdXJyZW50Q29sb3IiPjxwYXRoIGQ9Ik05IDE5TDkgMTYuOEM5IDE1IDEwLjMgMTMuNiAxMiAxMy42IDEzLjcgMTMuNiAxNSAxNSAxNSAxNi44TDE1IDE5IDkgMTlaTTggMjFMNyAyMSAzIDIxIDUgMTEuOSA3LjYgOS43IDggNi40IDE1IDQgMTYuNiA5LjYgMTkgMTAuNSAyMSAyMSAxOCAyMSAxNi41IDIxIDggMjFaIi8+PC9nPjwvZz48L3N2Zz4K";
export { ForwardRef as ReactComponent };